import React from 'react';
import ForgotPassword from './ForgotPassword';
import Layout from '../../components/Layout/Layout';
import Auth from '../../components/Auth';

function action() {
  if (Auth.isLogged()) {
    return {
      redirect: '/',
    };
  }

  return {
    title: 'Forgot Password',
    chunks: ['forgot-password'],
    component: (
      <Layout showFooter={false} showHeader={false}>
        <ForgotPassword />
      </Layout>
    ),
  };
}

export default action;
